import React from 'react'

const ComponentSpinner = ({ smallVersion = false }) => {
  if (smallVersion) {
    return (
      <div className='fallback-spinner' style={{ width: '30px', height: '30px' }}>
        <div className='loading' style={{ width: '30px', height: '30px' }}>
          <div className='effect-1 effects' style={{ width: '30px', height: '30px' }}></div>
          <div className='effect-2 effects' style={{ width: '30px', height: '30px' }}></div>
          <div className='effect-3 effects' style={{ width: '30px', height: '30px' }}></div>
        </div>
      </div>
    )
  } else {
    return (
      <div className='fallback-spinner'>
        <div className='loading'>
          <div className='effect-1 effects'></div>
          <div className='effect-2 effects'></div>
          <div className='effect-3 effects'></div>
        </div>
      </div>
    )
  }
}

export default ComponentSpinner
